var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frequently_asked_question"},[_c('h4',{staticClass:"question"},[_vm._v("\n\t\t"+_vm._s(_vm.faq.question)+"\n\t")]),_c('div',{staticClass:"answer",domProps:{"innerHTML":_vm._s(_vm.faq.answer)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }